export const confirm_password_update = `mutation confirm_password_update($input: AuthSecond!){
    confirm_password_update(input: $input)
}`;
